// extracted by mini-css-extract-plugin
export default {"label_phone":"FormFieldPhone-module__label_phone--FiHcw","label_phone__input":"FormFieldPhone-module__label_phone__input--s_ktL"};